export default __webpack_public_path__ + "static/capability-terminal-BY-83b067f869cc80276bafe1c9ee1e5343.png";